export const DIALOG_CLOSE_ANIMATION_MS = 200

export const DIALOG_NUDGE_ANIMATION_MS = 400

export const DIALOG_CLOSE_HINT_MS = 2000
